(() => {
  const canHover =
    window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hydrateHoverImage(card) {
    const wrapper = card?.querySelector('.c-product-card__image-wrapper--has-hover');
    const image = wrapper?.querySelector('.c-product-card__hover-image[data-gvs-hover-src]');

    if (!wrapper || !image || wrapper.classList.contains('is-hover-media-ready')) return;
    if (image.dataset.gvsHoverLoading === 'true') return;

    image.dataset.gvsHoverLoading = 'true';

    const markReady = () => {
      wrapper.classList.add('is-hover-media-ready');
      image.removeAttribute('data-gvs-hover-loading');
      image.removeAttribute('data-gvs-hover-src');
      image.removeAttribute('data-gvs-hover-srcset');
    };

    const disableHoverImage = () => {
      wrapper.classList.remove('c-product-card__image-wrapper--has-hover');
      image.removeAttribute('data-gvs-hover-loading');
      image.removeAttribute('data-gvs-hover-src');
      image.removeAttribute('data-gvs-hover-srcset');
    };

    image.addEventListener('load', markReady, { once: true });
    image.addEventListener('error', disableHoverImage, { once: true });

    if (image.dataset.gvsHoverSrcset) {
      image.srcset = image.dataset.gvsHoverSrcset;
    }

    image.src = image.dataset.gvsHoverSrc;

    if (image.complete && image.naturalWidth > 0) {
      markReady();
    }
  }

  if (canHover && !prefersReducedMotion) {
    document.addEventListener('pointerover', event => {
      const card = event.target.closest('.c-product-card');

      if (!card || card.contains(event.relatedTarget)) return;

      hydrateHoverImage(card);

      const video = card.querySelector('.c-product-card__video video');

      if (video) {
        video.play().catch(() => {});
      }
    });

    document.addEventListener('pointerout', event => {
      const card = event.target.closest('.c-product-card');

      if (!card || card.contains(event.relatedTarget)) return;

      const video = card.querySelector('.c-product-card__video video');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function announce(message) {
    let liveRegion = document.getElementById('gvs-cart-live-region');

    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'gvs-cart-live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.style.position = 'absolute';
      liveRegion.style.width = '1px';
      liveRegion.style.height = '1px';
      liveRegion.style.padding = '0';
      liveRegion.style.margin = '-1px';
      liveRegion.style.overflow = 'hidden';
      liveRegion.style.clip = 'rect(0, 0, 0, 0)';
      liveRegion.style.whiteSpace = 'nowrap';
      liveRegion.style.border = '0';
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = message;
  }

  window.addToCartAjax = async function addToCartAjax(event, form) {
    event.preventDefault();

    const id = form.querySelector('[name="id"]')?.value;
    const button = form.querySelector('button');
    const text = button?.querySelector('.add-btn-text');

    if (!id || !button || !text) return;

    const originalText = text.textContent;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    text.textContent = 'Adding...';

    try {
      const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id, quantity: 1 })
      });

      if (!response.ok) throw new Error('Add to basket failed');

      const item = await response.json();

      text.textContent = 'Added';
      announce(`${form.dataset.productTitle || 'Product'} added to basket.`);

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: item,
          sourceId: id,
          data: { source: 'c-product-card' }
        }
      }));

      document.querySelector('cart-drawer-component')?.showDialog();

      setTimeout(() => {
        text.textContent = originalText;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 2000);
    } catch (error) {
      text.textContent = originalText;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      announce(`Sorry, ${form.dataset.productTitle || 'the product'} could not be added to basket.`);
    }
  };
})();